var render = function render(_c, _vm) {
  return _c(
    "div",
    [
      _vm.props.svg && _vm.props.icon
        ? _c("svg-icon", { attrs: { "icon-class": _vm.props.icon } })
        : _vm.props.icon
        ? _c("i", { class: _vm.props.icon })
        : _vm._e(),
      _vm._v(" "),
      _vm.props.title
        ? _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.props.title)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }